import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getContactRelationship(contactId, params) {
        return Axios.get(`${baseURL}actor/contact-relationship/${contactId}`, {
            params
        }).then(response => response.data.response);
    },
    getCompanyRelationship(contactId, params) {
        return Axios.get(
            `${baseURL}account/contact-relationship/${contactId}`,
            {
                params
            }
        ).then(response => response.data.response);
    },
    deleteContactRelationship(contactId, params) {
        return Axios.delete(
            `${baseURL}actor/contact-relationship/${contactId}`,
            { params }
        ).then(response => response.data.response);
    },
    deleteCompanyRelationship(contactId, params) {
        return Axios.delete(
            `${baseURL}account/contact-relationship/${contactId}`,
            { params }
        ).then(response => response.data.response);
    },
    getTypes(params) {
        return Axios.get(`${baseURL}reference/contact-relation-type`, {
            params
        }).then(response => response.data.response);
    },
    createContactRelationship(params) {
        return Axios.post(`${baseURL}actor/contact-relationship`, params).then(
            response => response.data.response
        );
    },
    createCompanyRelationship(params) {
        return Axios.post(
            `${baseURL}account/contact-relationship`,
            params
        ).then(response => response.data.response);
    },
    updateContactRelationship(params) {
        return Axios.put(`${baseURL}actor/contact-relationship`, params).then(
            response => response.data.response
        );
    },
    updateCompanyRelationship(params) {
        return Axios.put(`${baseURL}account/contact-relationship`, params).then(
            response => response.data.response
        );
    }
};
